export default __webpack_public_path__ + "static/media/Machine Icon, White.b3832f15.png";